/**
 * 查看评语信息功能
 * @Author:wuTao
 * @Date 2020/09/15
 */
import React from 'react';
import {connect} from 'dva';

import {component_tool, framework_tool, utils_tool} from '@/tool';
import {modelUtils} from '@/utils';
import {WizAuthority, WizModalUserIdentityShow} from '@/containers/common';
import {commentDetailColumns, studentCommentColumns, studentCommentExcelColumns} from './columns'
import StudentCommentDetail from "../studentComment/studentCommentDetail";
import moment from "moment";

let {WizContainer} = framework_tool

let {Session, $$, checkStrLength, getPageData} = utils_tool;
let {
  WizRow, WizCol, WizTable, WizCard, WizSpin, WizTabs, WizButton,
  WizTag, WizSearchBar, WizDataTable, WizBrowserExport, WizModal
} = component_tool;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
class LookComment extends WizContainer {

  componentName = 'lookComment';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location.record) {
      initialValue = history.location.record;
      Session.set('lookCommentInfo', initialValue)
    } else {
      initialValue = Session.get('lookCommentInfo') || {};
    }
    this.state = {
      detailedVisible: false,
      manageKey: new Date().getTime(),
      commentDetailKey: new Date().getTime(),
      apiParams: {},
      studentCommentRecord: {},
      studentCommentVisible: false,
      studentCommentModalKey:new Date().getTime(),
      userIdentityVisible: false,
    };
    this.initialValue = initialValue;
    this.initialValue.detailedList = [];
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      //需初始化数据
      this.getTrainPathCommentDetailedByTrainPathCommentId();
      this.getStudentCommentData();
    }
    if (this.initialValue && this.initialValue.manageTargetScope && this.initialValue.id) {
      //需初始化的受众对象数据
      this.getTrainPathCommentTargetScopeInfo()
    }
  }

  propsAndStateOnChange = {
    trainPathCommentDetailedList: this._getTrainPathCommentDetailedListOver.bind(this),
    trainPathCommentTargetScopeInfo: this._getTrainPathCommentTargetScopeInfoOver.bind(this),
    getStudentCommentDataList: this._getStudentCommentDataListHandle.bind(this),
    studentCommentExcelFile: this._handleStudentCommentExcelFile.bind(this),
  };

  /**查看时时获取对应的评语考核内容明细数据 */
  getTrainPathCommentTargetScopeInfo() {
    this.doAction({
      path: 'trainPathCommentManagement/targetScopeInfo',
      payload: {
        key: 'trainPathCommentTargetScopeInfo',
        apiParams: {
          id: this.initialValue.id,
        }
      }
    });
  }

  /**查看时时获取对应的学员路径评语数据 */
  getStudentCommentData(other = {}) {
    this.doAction({
      path: 'studentCommentManagement/pageList',
      payload: {
        key: 'studentCommentManagement@pageList',
        apiParams: {
          ...this.state.apiParams, ...other,
          pathCommentId: this.initialValue.id,
        }
      }
    });
  }

  _getStudentCommentExcelList(other = {}) {
    this.doActions([
      {
        path: 'studentCommentManagement/list',
        payload: {
          key: 'studentCommentExcelFile',
          apiParams: {
            ...this.state.apiParams, ...other,
            pathCommentId: this.initialValue.id,
          }
        }
      },
    ]);
  }

  /**查看时时获取对应的评语考核内容明细数据 */
  getTrainPathCommentDetailedByTrainPathCommentId() {
    this.doAction({
      path: 'trainPathCommentDetailedManagement/list',
      payload: {
        key: 'trainPathCommentDetailedList',
        apiParams: {
          trainPathCommentId: this.initialValue.id,
        }
      }
    });
  }

  /**
   * 将查询到的评语受众对象内容明细数据
   */
  _getTrainPathCommentTargetScopeInfoOver(nextProps, nextState) {
    let trainPathCommentTargetScopeInfo = nextProps.trainPathCommentTargetScopeInfo.data;
    if (nextProps.trainPathCommentTargetScopeInfo.code == 1 && trainPathCommentTargetScopeInfo) {
      const {scopeCount, successCount} = trainPathCommentTargetScopeInfo;
      let manageTargetScope = this.initialValue.manageTargetScope;
      if (manageTargetScope) {
        manageTargetScope.message = ['受众人数 ' + scopeCount + '人', '提交人数 ' + successCount + '人']
      }
      nextState.manageKey = new Date().getTime();
      this.initialValue.manageTargetScope = manageTargetScope;
    }
    return true;
  }

  _getStudentCommentDataListHandle(nextProps, nextState) {
    let o = nextProps.getStudentCommentDataList;
    if (o['success']) {
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleStudentCommentExcelFile(nextProps, nextState) {
    let o = nextProps.studentCommentExcelFile;
    let columns = studentCommentExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let userIdentityInfos = d.userIdentityInfos;
        let info = userIdentityInfos && userIdentityInfos.split(',').length ? userIdentityInfos.replace(/,/g,";") : ''
        d.userIdentityInfos = info;
        _data.push(d);
      });
      let dateTime = formatterDate(new Date());
      WizBrowserExport({
        title: '学员评语记录信息',
        sheetName: '学员评语记录信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '学员评语记录信息-'+dateTime+'.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  /**
   * 将查询到的评语考核内容明细数据
   */
  _getTrainPathCommentDetailedListOver(nextProps, nextState) {
    let trainPathCommentDetailedList = nextProps.trainPathCommentDetailedList.data;
    if (nextProps.trainPathCommentDetailedList.code == 1 && trainPathCommentDetailedList && trainPathCommentDetailedList.length) {
      //重新排序
      trainPathCommentDetailedList.sort(function (a, b) {
        if (a['sort'] < b['sort']) {
          return -1
        }
        if (a['sort'] > b['sort']) {
          return 1
        }
        return 0;
      });
      let neoValue = Object.assign([]);
      if (trainPathCommentDetailedList) {
        trainPathCommentDetailedList.forEach(data => {
          const {sort} = data;
          data.key = new Date().getTime() + sort + '_commentDetail';
          neoValue.push(data);
        })
      }
      nextState.commentDetailKey = new Date().getTime();
      this.initialValue.detailedList = neoValue;
    }
    return true;
  }

  _openStudentCommentModel(val) {
    this.setState({
      studentCommentRecord: val,
      studentCommentVisible: true,
      studentCommentModalKey:new Date().getTime(),
    });
  }

  _openUserIdentityModel(val) {
    this.setState({
      studentCommentRecord: val,
      userIdentityVisible: true,
    });
  }

  _render() {
    const {trainPathCommentManagementLoading, trainPathCommentDetailedManagementLoading, getStudentCommentDataList} = this.props;
    const {userIdentityVisible, studentCommentVisible, studentCommentRecord} = this.state;
    let initialValue = this.initialValue;
    let dataItems = getPageData(getStudentCommentDataList.data);
    let other = {};
    let columns = commentDetailColumns(this, initialValue && initialValue.detailedList ? initialValue.detailedList : [], other);
    let studentCommentColumn = studentCommentColumns(this, dataItems, other);
    let searchBarProps = {
      columns: studentCommentColumn,
      cols: {
        xs: 24,
        md: 12,
        xl: 8
      },
      // cols: {xs: 14, md: 12, xl: 10},
      onSearch: values => {
        values.pathCommentId = this.initialValue.id
        this.setState({apiParams: values}, () => {
          this.getStudentCommentData();
        })
      }
    };
    let dataTableProps = {
      columns: studentCommentColumn,
      rowKey: "id",
      dataItems,
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this.getStudentCommentData({current: pageNum, size: pageSize});
      }
    }
    let lookUserPersonInfoModal = {
      title: '查看任职',
      visible: userIdentityVisible,
      personId: studentCommentRecord && studentCommentRecord.personId ? studentCommentRecord.personId : null,
      orgId: null,
      positionId: null,
      onCancel: (e) => {
        this.setState({
          userIdentityVisible: false,
          studentCommentRecord: {},
        });
      },
    };
    let lookStudentCommentDetailModal = {
      title: '查看评语',
      visible: studentCommentVisible,
      footer: null,
      width: 850,
      onCancel: (e) => {
        this.setState({
          studentCommentVisible: false,
          studentCommentRecord: {},
        });
      },
    }
    let studentOther = {record: studentCommentRecord}
    return (
      <>
        <WizSpin tip={'加载中'} spinning={trainPathCommentManagementLoading || trainPathCommentDetailedManagementLoading}>
          <WizCard title={'评语信息'}>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}>{'名称' + '：'}</WizCol>
              <WizCol span={16}>
                <span>{initialValue && initialValue.name ? initialValue.name : ''}</span>
                <span style={{marginLeft: 30}}>
                  <WizTag
                    color="green">{!initialValue || !initialValue.state || initialValue.state === 1 ? '草稿' : initialValue.state === 2 ? '已发布' : '已关闭'}</WizTag>
                </span>
              </WizCol>
            </WizRow>
            <WizRow className='administrationScope-row-item'>
              <WizCol className='col-item' span={3} offset={1}>{'介绍' + '：'}</WizCol>
              <WizCol
                span={16}>{initialValue && initialValue.briefIntroduction ? initialValue.briefIntroduction : ''}</WizCol>
            </WizRow>
          </WizCard>
          <WizCard>
            <WizTabs animated={false}>
              <WizTabs.TabPane tab="管理范围" key={'comment_manageTargetScope'}>
                <WizAuthority key={this.state.manageKey}
                              value={initialValue && initialValue.manageTargetScope ? initialValue.manageTargetScope : {}}
                              mode='Show'/>
              </WizTabs.TabPane>
              <WizTabs.TabPane tab="考核内容列表" key={'comment_detail'}>
                <WizTable pagination={false} key={this.state.commentDetailKey} columns={columns}
                          dataSource={initialValue && initialValue.detailedList ? initialValue.detailedList : []}/>
              </WizTabs.TabPane>
              <WizTabs.TabPane tab="评语记录列表" key={'comment_record'}>
                <WizSearchBar
                  type="grid" key={'student_comment_search'}
                  {...searchBarProps}
                />
                <WizButton.WizGroup>
                  <WizButton type='export' title="导出评语记录"
                             onClick={e => this._getStudentCommentExcelList()}>导出评语记录</WizButton>
                </WizButton.WizGroup>
                <WizDataTable {...dataTableProps} />
                <div className='pagination'>
                  <WizDataTable.Pagination {...dataTableProps} />
                </div>
                <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
                <WizModal key={'lookCommentDetail'+this.state.studentCommentModalKey} {...lookStudentCommentDetailModal}>
                  <StudentCommentDetail {...studentOther}/>
                </WizModal>
              </WizTabs.TabPane>
            </WizTabs>
          </WizCard>
        </WizSpin>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {trainPathCommentManagement, trainPathCommentDetailedManagement, studentCommentManagement} = state;
  const trainPathCommentDetailedList = modelUtils.getModelEntity(trainPathCommentDetailedManagement, "trainPathCommentDetailedList");
  const trainPathCommentTargetScopeInfo = modelUtils.getModelEntity(trainPathCommentManagement, "trainPathCommentTargetScopeInfo");
  const getStudentCommentDataList = modelUtils.getModelEntity(studentCommentManagement, "studentCommentManagement@pageList");
  const studentCommentExcelFile = modelUtils.getModelEntity(studentCommentManagement, "studentCommentExcelFile");
  const load = modelUtils.getLoadingState(state, ['trainPathCommentManagement', 'trainPathCommentDetailedManagement']);
  return {
    trainPathCommentDetailedList: trainPathCommentDetailedList,
    trainPathCommentTargetScopeInfo: trainPathCommentTargetScopeInfo,
    getStudentCommentDataList: getStudentCommentDataList,
    studentCommentExcelFile: studentCommentExcelFile,
    ...load
  }
};

export default connect(mapStateToProps)(LookComment);
